import { httpClient, type BlobResponse } from "@/lib/httpClient";

export interface GenerateLettersInput {
  file: File;
  /** Map of required field name → the CSV column header to read it from. */
  mapping: Record<string, string>;
  labelTemplate: string;
  csrfToken: string;
}

export interface NetsuiteTransformResult {
  emailCsv: string;
  smsCsv: string;
  emailFilename: string;
  smsFilename: string;
  rowsIn: number;
  emailContactsCount: number;
  smsContactsCount: number;
  dupesRemoved: number;
  rowsSkippedNoEmail: number;
  rowsSkippedNoPhone: number;
  roleBasedCount: number;
}

export interface TransformNetsuiteContactsInput {
  file: File;
  csrfToken: string;
}

/**
 * Client API for the team Tools. Each tool's calls live here so components
 * depend on this interface, not on endpoint URLs (ARCHITECTURE: services own
 * network access).
 */
export const toolsService = {
  /**
   * Generate prospect letters + mailing labels from a CSV. Returns the ZIP blob
   * and the server-suggested filename; the caller triggers the download.
   */
  generateProspectLetters(input: GenerateLettersInput): Promise<BlobResponse> {
    const form = new FormData();
    form.append("csv_file", input.file);
    form.append("column_mapping", JSON.stringify(input.mapping));
    form.append("label_template", input.labelTemplate);
    return httpClient.postForm("/api/tools/prospect-letter/generate", form, {
      "x-csrf-token": input.csrfToken,
    });
  },

  /**
   * Transform a NetSuite contacts xlsx export. Returns stats and both CSV
   * strings as JSON; the caller builds Blobs and triggers downloads client-side.
   */
  transformNetsuiteContacts(
    input: TransformNetsuiteContactsInput
  ): Promise<NetsuiteTransformResult> {
    const form = new FormData();
    form.append("xlsx_file", input.file);
    return httpClient.postFormJson<NetsuiteTransformResult>(
      "/api/tools/netsuite-contacts/transform",
      form,
      { "x-csrf-token": input.csrfToken }
    );
  },
};
